import React, { Component } from 'react';
import CategoryItem from '../CategoryItem';
import withProducts from '../../../../containers/Products';

class CategoryList extends Component {
  render() {
    const {
      categoryList,
      onChangeStatus,
      toggleListCategoryItem,
      isDragDisabled,
      isProductDragDisabled,
    } = this.props;

    return categoryList.map((item, index) => (
      <CategoryItem
        key={`${item.name}_${item.id}`}
        toggleListCategoryItem={toggleListCategoryItem}
        changeStatus={onChangeStatus}
        index={index}
        isDragDisabled={isDragDisabled}
        isProductDragDisabled={isProductDragDisabled}
        category={item}
      />
    ));
  }
}

export default withProducts(CategoryList);



// WEBPACK FOOTER //
// ./src/screens/Product/Categories/CategoryList/index.js